if (!customElements.get('shopde-footer-links')) {
  customElements.define('shopde-footer-links', class extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      if (!this.details || !this.summary) return;
      this.controller?.abort();
      this.controller = new AbortController();
      this.desktop = window.matchMedia('(min-width: 750px)');
      this.mobileOpen = false;
      const signal = this.controller.signal;
      const sync = () => {
        this.details.open = this.desktop.matches || this.mobileOpen;
        this.summary.tabIndex = this.desktop.matches ? -1 : 0;
      };
      this.desktop.addEventListener('change', sync, { signal });
      this.summary.addEventListener('click', event => {
        if (this.desktop.matches) event.preventDefault();
      }, { signal });
      this.details.addEventListener('toggle', () => {
        if (!this.desktop.matches) this.mobileOpen = this.details.open;
      }, { signal });
      sync();
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
